import { forwardRef } from 'react';
import { Text } from '@quintoandar-tokko/jopijs';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import GenericBarChart from '@/components/Dashboard/Charts/GenericBarChart';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import getBarChartYAxisScale from '@/components/Dashboard/utils/getBarChartYAxisScale';
import styles from './staleRecordsCard.module.scss';

const StaleRecordsCard = forwardRef(
  (
    {
      loading,
      data,
      icon,
      titleKey,
      titleInfoTooltipKey,
      emptyStateTitleKey,
      forceEmptyState = false,
      trackShowAll,
      trackBar,
      ...rest
    },
    ref
  ) => {
    const { totalCount, headerUrl, labels, datasets } = data;
    const isEmpty = forceEmptyState || totalCount === 0;
    const { max: yMax, stepSize: yTicksStepSize } = getBarChartYAxisScale(
      datasets[0]?.data
    );

    const handleBarClick = ({ label }) => {
      if (!label?.url) return;

      trackBar();
      window.open(label.url, '_blank');
    };

    const getTooltipLabel = (context) => {
      const rangeLabel = labels[context.dataIndex]?.name || context.label;
      return `${rangeLabel}: ${context.raw}`;
    };

    return (
      <PendingCard ref={ref} loading={loading} {...rest}>
        <PendingCard.Header
          redirectUrl={isEmpty ? null : headerUrl}
          toolTipText={Trans(translations, 'ShowAll')}
          infoTooltipText={
            titleInfoTooltipKey ? Trans(translations, titleInfoTooltipKey) : ''
          }
          trackCallback={trackShowAll}
        >
          {Trans(translations, titleKey)}
        </PendingCard.Header>

        {isEmpty ? (
          <DashboardEmptyStateCard
            icon={icon}
            title={Trans(translations, emptyStateTitleKey)}
          />
        ) : (
          <>
            <Text className={styles.totalCount}>{totalCount}</Text>
            <GenericBarChart
              labels={labels}
              datasets={datasets}
              yMax={yMax}
              yTicksStepSize={yTicksStepSize}
              onBarClick={handleBarClick}
              getTooltipLabel={getTooltipLabel}
            />
          </>
        )}
      </PendingCard>
    );
  }
);

export default StaleRecordsCard;
